/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

function ContactUs({
  email = 'utechdynamics@gmail.com',
  phone = '+88-01949-403199',
}) {
  const handleEmailClick = () => {};
  const handleCallClick = () => {};
  const handleContactClick = (type) => {
    console.log('Contact via', type);
  };

  return (
    <div className="min-h-screen w-full bg-gray-100 flex items-center justify-center">
      <div className="max-w-3xl w-full bg-white shadow-lg rounded-xl p-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Get in Touch</h2>

        {/* Contact Links */}
        <div className="flex flex-col md:flex-row md:space-x-6 space-y-4 md:space-y-0 mb-8">
          <a
            href={`mailto:${email}?subject=${encodeURIComponent('Promote & Earn Inquiry')}`}
            onClick={handleEmailClick}
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 text-center"
          >
            Email Us
          </a>
          <a
            href={`tel:${phone.replace(/[^+\d]/g, '')}`}
            onClick={handleCallClick}
            className="px-4 py-2 rounded bg-stone-800 text-white hover:bg-stone-900 text-center"
          >
            Call Us
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=8801949403199"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
            onClick={() => handleContactClick('whatsapp')}
          >
            <FaWhatsapp className="text-xl" />
            <span>Chat on WhatsApp</span>
          </a>
        </div>
        <div className="w-full flex-col justify-center " />
        {' '}
        <p className="flex item-center justify-center text-green-600">OR</p>
        <div />
        {/* Contact Form */}
        <form className="space-y-4">
          <input
            type="text"
            placeholder="Your Name"
            required
            className="w-full border rounded px-3 py-2 focus:ring focus:ring-blue-600"
          />
          <input
            type="email"
            placeholder="Your Email"
            required
            className="w-full border rounded px-3 py-2 focus:ring focus:ring-blue-300"
          />
          <input
            type="tel"
            placeholder="Your Phone Number"
            required
            className="w-full border rounded px-3 py-2 focus:ring focus:ring-blue-300"
          />
          <input
            type="text"
            placeholder="Your WhatsApp Number"
            required
            className="w-full border rounded px-3 py-2 focus:ring focus:ring-green-300"
          />
          <textarea
            placeholder="Your Message"
            required
            className="w-full border rounded px-3 py-2 h-32 focus:ring focus:ring-blue-300"
          />
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactUs;
